import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["display", "form", "icon"];

  toggle(event) {
    event.preventDefault();

    this.displayTarget.classList.toggle("hidden");
    this.formTarget.classList.toggle("hidden");

    this.updateIcon();

    if (!this.formTarget.classList.contains("hidden")) {
      this.focusInput();
    }
  }

  submit(event) {
    const form = this.formTarget.querySelector("form");
    if (form) {
      form.requestSubmit();
    }
  }

  updateIcon() {
    const svg = this.iconTarget.querySelector("svg");
    if (this.formTarget.classList.contains("hidden")) {
      svg.classList.remove("fa-check");
      svg.classList.add("fa-pencil");
    } else {
      svg.classList.remove("fa-pencil");
      svg.classList.add("fa-check");
    }
  }

  focusInput() {
    const input = this.formTarget.querySelector("input[type]");
    if (input) {
      input.focus();
      input.select();
    }
  }
}
